import { Promotion } from "@/@types/workshop"

export function findTicketLot(promotions: Promotion[]) {
  const now = new Date().getTime()

  const batch = promotions.findIndex((promotion) => {
    const startTime = new Date(promotion.start_date).getTime()

    const endDate = new Date(promotion.end_date)
    endDate.setHours(23, 59, 59, 999)
    const endTime = endDate.getTime()

    return now >= startTime && now <= endTime
  })

  if (batch > -1) return batch

  return 0
}